<script lang="ts" setup>
import { onMounted, ref } from 'vue'

import TradingFooter from '@/components/TradingBlock/TradingFooter.vue'
import { getLanguage } from '@/helpers/language-helper'
import RedirectButton from '@/components/RedirectButton/RedirectButton.vue'

defineProps({ data: Object })

const lang = ref<any>()
onMounted(() => {
  lang.value = getLanguage()
})
</script>
<template>
  <div class="flex flex-col items-center lg:items-start lg:flex-row">
    <div
      class="flex flex-col md:justify-start items-center md:items-start w-full md:max-w-[346px] mt-10 md:ml-10"
    >
      <div class="relative flex justify-center w-full lg:justify-start -z-10">
        <div class="lg:h-[107px]">
          <img loading="lazy" :src="data?.logo" :alt="data?.logo_alt" />
        </div>
        <div
          class="w-full text-base px-[10px] md:px-[0px] lg:w-[310px] -tracking-tightest absolute -bottom-[109px] lg:-bottom-[115px]"
          :class="lang === 'ko' ? 'break-keep' : ''"
        >
          {{ data?.description }}
        </div>
      </div>

      <div class="flex justify-center w-full mt-30 lg:hidden">
        <img loading="lazy" :src="data?.main_image_mobile" :alt="data?.main_image.alt" />
      </div>
      <div class="lg:mt-[220px] w-full md:px-0 px-[10px] md:max-w-[311px]">
        <RedirectButton
          :href="data?.action_button_link"
          :text="data?.action_button_text"
          type="primary"
        />
        <div class="flex justify-center md:justify-between gap-2.5 lg:gap-0">
          <button type="button">
            <a :href="data?.google_play_link" target="_blank">
              <picture>
                <source media="(max-width: 600px)" :srcset="data?.google_play_icon_mobile" />
                <source media="(min-width: 601px)" :srcset="data?.google_play_icon" />
                <img loading="lazy" :src="data?.google_play_icon" />
              </picture>
            </a>
          </button>
          <button type="button">
            <a :href="data?.app_store_link" target="_blank">
              <picture>
                <source media="(max-width: 600px)" :srcset="data?.app_store_icon_mobile" />
                <source media="(min-width: 601px)" :srcset="data?.app_store_icon" />
                <img loading="lazy" :src="data?.app_store_icon" />
              </picture>
            </a>
          </button>
        </div>
      </div>
    </div>
    <div class="items-start hidden mt-12 lg:flex min-h-[596px]">
      <img loading="lazy" :src="data?.main_image" />
    </div>
  </div>
  <TradingFooter
    :lang="lang"
    :titleOne="data?.footer_column_one_title"
    :contentOne="data?.footer_column_one_content"
    :titleTwo="data?.footer_column_two_title"
    :contentTwo="data?.footer_column_two_content"
    :titleThree="data?.footer_column_three_title"
    :contentThree="data?.footer_column_three_content"
    :titleFour="data?.footer_column_four_title"
    :contentFour="data?.footer_column_four_content"
    :footerIconLink="data?.footer_icon"
    :footerIconAlt="data?.footer_icon_alt"
    class="lg:mb-20"
  ></TradingFooter>
</template>
